export default __webpack_public_path__ + "static/media/exclamation.6ffdd350.svg";